import React from 'react'
import DatePicker, { ReactDatePickerProps } from 'react-datepicker'
import styles from './DateInputWithForm.module.css'
import { Controller } from 'react-hook-form';

interface DateInputWithFormProps {
    name: string;
    showIcon : boolean;
    selectedDate : any;
    onChangeDate : (e : any) => void;
    showPopperArrow : boolean;
    control:any
}
interface CustomDatePickerProps extends ReactDatePickerProps {
  toggleCalendarOnIconClick?: boolean;
}
const DateInputWithForm: React.FC<DateInputWithFormProps> = (props) => {
    const {
     name,
     showIcon,
     selectedDate,
     onChangeDate,
     showPopperArrow,
     control
    } = props;

  const onValueChanges = (e : any,onChange : any,value: any) => {
     onChange(e)
     if(onChangeDate){
      onChangeDate(e);
     }
  }
  return (
    <Controller
      control={control}
      name = {name}
      render={({field : {onChange, value}}) => (
        <DatePicker
        id={`date-picker-${name}`}
        name={name}
        {...{toggleCalendarOnIconClick: true} as CustomDatePickerProps}
        dateFormat={'MM-DD-YYYY'}
        value={value}
        showIcon = {showIcon}
        calendarIconClassname ={`${styles.calenderIconStart}`}
        selected={selectedDate}
        onChange={(e) => onValueChanges(e,onChange,value)}
        className={` ${styles.customDatePickerInput}`}
        showPopperArrow={showPopperArrow}
        popperClassName={name === 'fromDate' ? `${styles.popperContainerStyle}` : ``}
        placeholderText={`MM/DD/YYYY`}
        calendarClassName={name === 'toDate' ? `${styles.calendarClassName}` : ''}
        maxDate={new Date()}
        wrapperClassName={styles.wrapperStyle}
        onKeyDown={(e) => {
            e.preventDefault();
        }}
        /> 
      )}
    />
  );
}

export default DateInputWithForm


  